import { render, staticRenderFns } from "./laiyuan.vue?vue&type=template&id=21614bef&scoped=true"
import script from "./laiyuan.vue?vue&type=script&lang=js"
export * from "./laiyuan.vue?vue&type=script&lang=js"
import style0 from "./laiyuan.vue?vue&type=style&index=0&id=21614bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21614bef",
  null
  
)

export default component.exports